import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import ProductDetails from "./pages/ProductDetails";
import ShoppingCart from "./pages/Cart";
import Register from "./pages/Register";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import SecondHand from "./pages/SecondHand";
import AllCategories from "./pages/AllCategories";
import CategoryPage from "./pages/Category";
import Pricing from "./pages/Pricing.js";
import Contact from "./pages/Contact.js";
import { UserProvider } from "./context/userContext";
import Admin from "./pages/Admin/Admin";
import Product from "./pages/Admin/Product.js";
import Wishlist from "./pages/Wishlist.js";
import SignupPage from "./pages/SignupPAge.js";
import VerificationPage from "./pages/VerificationPage.js";
import VerificationSuccessPage from "./pages/VerificationSuccessful.js";
import PersonalInfo from "./pages/PersonalInfo.js";
import AboutUs from "./pages/AboutUs.js";
import { CartProvider } from "./context/cartContext.js";
import { WishlistProvider } from "./context/wishlistContext.js";
import Profile from "./pages/Admin/Profile.js";
import SalesPage from "./pages/Admin/Sales.js";
import ProtectedRoute from "./routes/protectedRoutes.js";
import StepProtectedRoute from "./routes/stepProtectedRoutes.js";
import { SignupProvider } from "./context/signUpContext";
import { Navigate } from "react-router-dom";
import Checkout from "./pages/Checkout.js";
import SearchResults from "./pages/SearchResult.js";
import { ThemeProvider } from "./context/themeContext";
import ResetPasswordForm from "./pages/ResetPasswordForm.js";
import Superadmin from "./pages/SuperAdmin/SuperAdmin.js";
import UserManagement from "./pages/SuperAdmin/Users.js";
import CategoryManagement from "./pages/SuperAdmin/Category/Category.js";
import SubcategoryManagement from "./pages/SuperAdmin/Subcategory.js";
import CategoryAttributeManagement from "./pages/SuperAdmin/CategoryAttribute.js";
import SubcategoryAttributeManagement from "./pages/SuperAdmin/SubcategoryAttribute.js";
import ProductCategoryAttributeValueManagement from "./pages/SuperAdmin/ProductCategegoryAttributeValueManagement.js";
import SubcategoryAttributeValueManagement from "./pages/SuperAdmin/SubcategoryAttributeValueManagment.js";
import ProductAdmin from "./pages/SuperAdmin/ProductAdmin.js";
import SidebarButton from "./components/SidebarButton.js";
import DeliveryDashboard from "./pages/Transport/TransportDashboard.js";
import PaymentPage from "./pages/PaymentPage.js";
import Deliveries from "./pages/Transport/Delivery.js";
import Orders from "./pages/SuperAdmin/Orders.js";
import BuyerDashboard from "./pages/Buyer/BuyerDashboard.js";
import RenewSubscriptionPage from "./pages/Admin/Renew.js"
import PurchaseHistory from "./pages/Buyer/PurchaseHistory.js";
import SubscriptionPage from "./pages/SubscriptionPage.js";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PrivacyPolicy from "./pages/PrivacyAndPolicy.js";
const stripePromise = loadStripe(
  "pk_test_51NDEMaHB8rLE0wX12LWngeUZjcnS2peDAoVfxzhasrTUX9EPo1Sef2XlbJgsjZjZegGsVM3obfYaWfiXGJtWGyDs00qtV3PXsA"
);
function App() {
  return (
    <ThemeProvider>
      <SignupProvider>
        <CartProvider>
          <WishlistProvider>
            <UserProvider>
              <Router>
                <SidebarButton />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/product/:id" element={<ProductDetails />} />
                  <Route path="/cart" element={<ShoppingCart />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/second-hand" element={<SecondHand />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />

                  <Route path="/all-categories" element={<AllCategories />} />
                  <Route
                    path="/subscribtion"
                    element={
                      <Elements stripe={stripePromise}>
                        <SubscriptionPage />
                      </Elements>
                    }
                  />

                  <Route
                    path="/categories/:category_id"
                    element={<CategoryPage />}
                  />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/search" element={<SearchResults />} />
                  <Route path="/super-admin" element={<Superadmin />} />
                  <Route
                    path="/super-admin/users"
                    element={<UserManagement />}
                  />
                  <Route
                    path="/super-admin/categories"
                    element={<CategoryManagement />}
                  />
                  <Route
                    path="/super-admin/subcategories"
                    element={<SubcategoryManagement />}
                  />
                  <Route
                    path="/super-admin/category-attributes"
                    element={<CategoryAttributeManagement />}
                  />
                  <Route
                    path="/super-admin/subcategory-attributes"
                    element={<SubcategoryAttributeManagement />}
                  />
                  <Route
                    path="/super-admin/product-category-attribute-value"
                    element={<ProductCategoryAttributeValueManagement />}
                  />
                  <Route
                    path="/super-admin/product-subcategory-attribute-value"
                    element={<SubcategoryAttributeValueManagement />}
                  />
                  <Route
                    path="/super-admin/products"
                    element={<ProductAdmin />}
                  />
                  <Route path="/super-admin/orders" element={<Orders />} />
                  <Route path="/delivery" element={<DeliveryDashboard />} />
                  <Route path="/payment" element={<PaymentPage />} />
                  <Route path="/renew-subscription" element={<RenewSubscriptionPage />}/>
                  <Route
                    path="/dashboard/deliveries"
                    element={<Deliveries />}
                  />
                  <Route path="/buyer" element={<BuyerDashboard />} />
                  <Route
                    path="/user/purchase-history"
                    element={<PurchaseHistory />}
                  />
                  <Route
                    path="/admin"
                    element={
                      <ProtectedRoute
                        allowedRoles={["admin", "business", "premium"]}
                      >
                        <Admin />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/product"
                    element={
                      <ProtectedRoute
                        allowedRoles={["admin", "business", "premium"]}
                      >
                        <Product />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile"
                    element={
                      <ProtectedRoute
                        allowedRoles={["admin", "business", "premium","delivery","user"]}
                      >
                        <Profile />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/sales"
                    element={
                      <ProtectedRoute
                        allowedRoles={["admin", "business", "premium"]}
                      >
                        <SalesPage />
                      </ProtectedRoute>
                    }
                  />

                  <Route path="/wishlist" element={<Wishlist />} />
                  <Route path="/personal-info" element={<PersonalInfo />} />
                  <Route
                    path="/sign-up"
                    element={
                      <StepProtectedRoute requiredStep="personalInfo">
                        <SignupPage />
                      </StepProtectedRoute>
                    }
                  />
                  <Route
                    path="/verification"
                    element={
                      <StepProtectedRoute requiredStep="signUp">
                        <VerificationPage />
                      </StepProtectedRoute>
                    }
                  />
                  <Route
                    path="/verification-successful"
                    element={
                      <StepProtectedRoute requiredStep="verification">
                        <VerificationSuccessPage />
                      </StepProtectedRoute>
                    }
                  />

                  <Route path="/about-us" element={<AboutUs />} />
                  <Route path="/reset-form" element={<ResetPasswordForm />} />
                </Routes>
              </Router>
            </UserProvider>
          </WishlistProvider>
        </CartProvider>
      </SignupProvider>
    </ThemeProvider>
  );
}

export default App;
